import React from "react";
import "./theme.scss";
import classNames from "classnames";
import { IWebsiteBuilderTheme } from "redux/reducers/models/websiteBuilder";

type TThemeSelected = { selected: true };
type TThemeUnselected = { selected: false; selectTheme: () => void };

type TThemeSelection = TThemeSelected | TThemeUnselected;

type TThemeProps = {
  theme: IWebsiteBuilderTheme;
} & TThemeSelection;

export function Theme(props: TThemeProps) {
  function handleClick() {
    if (props.selected === false) {
      props.selectTheme();
    }
  }

  if (!props.theme) {
    return null;
  }

  return (
    <div
      className={classNames("website-builder-theme", {
        "theme-selected": props.selected,
      })}
      onClick={handleClick}
    >
      <div className="theme-title">{props.theme.title}</div>
      <div className="theme-colors">
        <div style={{ backgroundColor: props.theme.primary }} />
        <div style={{ backgroundColor: props.theme.secondary }} />
        <div style={{ backgroundColor: props.theme.tertiary }} />
        <div style={{ backgroundColor: props.theme.quaternary }} />
      </div>
    </div>
  );
}
